<template>
    <div class="upload-img">
        <div class="btns">
            <el-upload
                class="upload-demo"
                :action="upload_url"
                multiple
                :show-file-list="false"
                :on-success="(res, file, fileList) => handleSuccess(res, file, fileList)"
                :before-upload="beforeUpload"
                :headers="headers"
                :file-list="fileList">
                <el-button type="primary">点击上传</el-button>
            </el-upload>
            <el-button @click="getUrlDialogVisible = true">从URL获取</el-button>
            <el-button @click="selectDialogVisible = true">从产品图片选择</el-button>
        </div>

        <draggable
            class="img-box"
            tag="div"
            @end="handleDragEnd"
            :list="fileList"
            handle=".img-item"
            v-loading="loading"
        >
            <div class="img-item" v-for="(item, index) in fileList" :key="item.url">
                <img :src="item.url" alt="">
                <div class="img-tools">
                    <el-tooltip class="item" effect="dark" content="预览大图" placement="top">
                        <el-button icon="el-icon-search" @click="handlePreview(item)"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="设为主图" placement="top" v-if="index !== 0 && type === 'main'">
                        <el-button icon="el-icon-setting" @click="handleSetMain(item, index)"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <el-button icon="el-icon-delete" @click="handleRemove(item,index)"></el-button>
                    </el-tooltip>
                </div>
                <div class="zt-box" v-if="index === 0 && type === 'main'">主图</div>
            </div>
        </draggable>

        <el-dialog title="URL上传" :visible.sync="getUrlDialogVisible" :modal-append-to-body="false" :modal="false" width="40%">
            <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入图片链接，一行一项，回车键换行，请勿输入其他字符或空行"
            v-model="getUrlString">
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="getUrlDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleGetUrlConfirm">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="从产品图片选择" :visible.sync="selectDialogVisible" :modal-append-to-body="false" :modal="false" width="80%" :before-close="handleSelectDialogClose" top="5vh">
            <div class="select-box">
                <div class="text">请选择SKU：</div>
                <el-select v-model="value" placeholder="请选择SKU"  @change="getSelectImg" filterable>
                    <el-option v-for="item in selectSkuList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </div>
            
            <div class="img-box">
                <div class="img-item" :class="{active: activeImgList.includes(item)}" v-for="item in selectImgList" :key="item" @click="handleSelectImg(item)">
                    <img :src="item" alt="">
                    <div class="active-box" v-if="activeImgList.includes(item)">√</div>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="selectDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSelectConfirm">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
import draggable from "vuedraggable";
export default {
    components: {
        draggable,
    },
    props:{
        formData:{
            type: Object,
            default: () => {}
        },
        upload_url: {
            type: String,
            required: true,
        },
        fileList: {
            type: Array,
            default: () => [],
        },
        selectSkuList: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
        },
    },
    data() {
        return {
            getUrlDialogVisible: false,
            getUrlString: '',
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            selectDialogVisible: false,
            tableData: [{
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
                }, {
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
                }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
                }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
                }, {
                date: '2016-05-08',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
                }, {
                date: '2016-05-06',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
                }, {
                date: '2016-05-07',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }],
            value: '',
            multipleSelection: [],
            loading: false,
            headers: {},
            selectImgList: [],
            activeImgList: [],
        }
    },
    created(){
        this.headers = {
            'token': localStorage.getItem('token'),
        }
    },
    methods:{
        handleSelectImg(url){
            if(this.activeImgList.includes(url)){
                this.activeImgList = this.activeImgList.filter(item => item !== url);
            }else{
                this.activeImgList.push(url);
            }
        },
        handleSelectDialogClose(){
            this.activeImgList = [];
            this.selectDialogVisible = false;
        },
        getSelectImg(){
            this.activeImgList = [];
            const params = {
                sku: this.value,
            }
            ajaxPost(Baseurl + '/productController/selectProductImgList', params).then(res => {
                if(res.data.code === 200){
                    this.selectImgList = res.data.data;
                }else{
                    this.selectImgList = [];
                }
                if(this.selectImgList.length === 0){
                    this.$message.warning('没有找到对应的图片');
                }
            })
        },
        handleSetMain(file, newIndex){
            const oldIndex = this.fileList.findIndex(item => item.url === this.formData.image);
            const updatedData = {
                ...this.formData,
                image: file.url
            }
            this.$emit('updateFormData', updatedData);
            if(this.fileList.length > 1){
                const arr = JSON.parse(JSON.stringify(this.fileList));
                if(oldIndex === -1){ //如果主图不存在，则将新上传的主图放在第一个位置
                    arr.unshift(arr.splice(newIndex, 1)[0]);
                }else{
                    const temp = arr[oldIndex];
                    arr[oldIndex] = arr[newIndex];
                    arr[newIndex] = temp;
                }
                this.$emit('updatefileList', arr); //设置主图以后，修改传进来的数据
            }
        },
        handlePreview(file) {
            // 处理图片预览
            window.open(file.url)
        },
        handleGetUrl(){
            this.getUrlDialogVisible = true;
        },
        handleGetUrlConfirm(){
            if(this.getUrlString.trim() === ''){
                this.$message.error('请输入图片链接');
                return;
            }
            const arr1 = [...new Set(this.getUrlString.split('\n'))];
            const arr = arr1.map(item => {
                return {
                    url: item.trim(),
                    uid: Date.now() + Math.random().toString(36).substr(2)
                }
            });
            this.$emit('updatefileList', [...this.fileList, ...arr]);
            this.getUrlDialogVisible = false;
            this.getUrlString = '';
        },
        handleRemove(file,index) {
            // 处理图片移除
            this.$emit('delData', {data: file, index})
        },
        beforeUpload(){
            this.loading = true;
            return true;
        },
        handleSuccess(res, file, fileList) {
            if (res.code === 200) {
                this.$message.success('上传成功!');
                // 更新对应类型的图片列表
                const arr = fileList.map(item => ({
                    ...item,
                    url: item.response?.data || item.url || item.imageUrl,
                    uid: item.uid || Date.now() + Math.random().toString(36).substr(2)
                }));
                this.$emit('updatefileList', arr); //删除和新增都会触发
                this.loading = false;
            } else {
                this.$message.error(res.data || '上传失败!');
                this.loading = false;
            }
        },
        handleSelectConfirm(){
            this.$emit('updatefileList', [...this.fileList, ...this.activeImgList.map((item)=>{
                return {
                    url: item,
                    uid: Date.now() + Math.random().toString(36).substr(2)
                }
            })]);
            this.selectDialogVisible = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleDragEnd(){
            this.$emit('dragEnd', this.fileList);
        }
    }
}
</script>

<style lang="scss" scoped>
    .img-box{
        display: flex;
        flex-wrap: wrap;
        .img-item{
            width: 120px;
            height: 120px;
            border-radius: 5px;
            margin-right: 8px;
            margin-bottom: 8px;
            border: 1px solid #e5e5e5;
            position: relative;
            box-sizing: border-box;
            &:hover{
                .img-tools{
                    opacity: 1;
                }
            }
            img{
                border-radius: 5px;
                width: 100%; 
                height: 100%;
                object-fit: contain;
            }
            .img-tools{
                position: absolute;
                bottom: 0;
                right: 0;
                display: flex;
                width: 100%;
                justify-content: space-evenly;
                background-color: rgba(0, 0, 0, 0.5);
                padding: 5px 10px;
                box-sizing: border-box;
                opacity: 0;
                transition: opacity 0.3s ease;


                .el-button{
                    margin: 0;
                    padding: 5px;
                    // width: 20px;
                    height: 25px;
                    box-sizing: border-box;
                    border: none;
                    background-color: transparent;
                    color: #fff;
                    border-radius: 50%;
                    font-size: 16px;
                }
            }
            .zt-box{
                position: absolute;
                border-radius: 2px;
                top: 0;
                right: 0;
                font-size: 12px;
                color: #fff;
                background-color: #28a864;
                padding: 0 4px;
                line-height: 16px;
                height: 16px;
            }
            &.active{
                border: 2px solid #28a864;
                ::before{
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 0;
                    height: 0;
                    border-top: 30px solid #28a864;       /* 三角形颜色 */
                    border-left: 30px solid transparent;  /* 透明形成三角角度 */
                }
                ::after{
                    content: '√';
                    color: #fff;
                    top: 0;
                    right: 2px;
                    position: absolute;

                }
            }
        }
        
    }
    .btns{
        display: flex;
        margin-bottom: 20px;
        .el-button{
            margin: 0;
            margin-right: 10px;
        }
    }
    .select-box{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
</style>